function imageLoadedHandler(event) {
   event.target.classList.add("loaded");
}

window.addEventListener("DOMContentLoaded", () => {
   document.querySelectorAll("img").forEach(image => {
      if (image.complete) {
         image.classList.add("loaded");
      } else {
         image.addEventListener("load", imageLoadedHandler);
      }
   });
});
